module.exports = __webpack_public_path__ + "img/Bingo2_Info_Game_6.62b1821e.png";